import React from 'react';
import { externalRoutes } from 'routes/urlMap';
import { faHeadset } from '@fortawesome/pro-regular-svg-icons';
import getText from 'context/language/getText';
import { NavGroup } from '../components';

export const SupportLink = () => {
  const links = [
    {
      url: externalRoutes.FAQ,
      external: true,
      textPath: 'navbar.support.faq',
      name: 'support-faq'
    },
    {
      url: externalRoutes.SUPPORT,
      external: true,
      textPath: 'navbar.support.contact',
      name: 'support-contact'
    }
  ];

  return (
    <NavGroup
      links={links}
      icon={faHeadset}
      label={getText('navbar.support.title')}
      name="support"
    />
  );
};
